module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "title": "Info sui livelli della mappa"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ae3d471e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Info.vue
// module id = 904
// module chunks = 39